<div class="container">
  <div [formGroup]="graduation">
    <div class="row">
      <div class="col-md-12">
        <mat-form-field class="graddate datepicker">
          <input matInput [matDatepicker]="grad" (click)="grad.open()" placeholder="{{TITLE}} Month and Year" formControlName="graduationdate" [min]="minDate" [max]="maxDate">
          <mat-datepicker-toggle matSuffix [for]="grad"></mat-datepicker-toggle>
          <mat-datepicker #grad startView="multi-year" (yearSelected)="chosenYearHandler($event)" (monthSelected)="chosenMonthHandler($event, grad)"></mat-datepicker>

          <!-- <mat-error *ngIf="graduationDate.errors">
            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Required
          </mat-error> -->

          <mat-error *ngIf="graduationDate.errors">

            <span *ngIf="graduationDate.errors?.incorrectDateValue; else others">
              <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Your Graduation Date indicates a different Member Type
            </span>
            <ng-template #others>
              <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Required (MM/YYYY)
            </ng-template>
          </mat-error>


        </mat-form-field>
      </div>
    </div>
  </div>
</div>
